import script from "./FilterCriteriaPercent.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterCriteriaPercent.vue?vue&type=script&setup=true&lang=js"

import "./FilterCriteriaPercent.vue?vue&type=style&index=0&id=f9784592&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9784592"]])

export default __exports__